import React from "react";
export const ProfileIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.625 1.75H4.375C2.92525 1.75 1.75 2.92525 1.75 4.375V15.625C1.75 17.0747 2.92525 18.25 4.375 18.25H15.625C17.0747 18.25 18.25 17.0747 18.25 15.625V4.375C18.25 2.92525 17.0747 1.75 15.625 1.75Z"
      stroke="#808192"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1403 14.0187C13.0759 13.2709 12.7205 12.5784 12.1507 12.0899C11.5809 11.6015 10.8421 11.3563 10.0933 11.4069C9.34451 11.3563 8.60574 11.6015 8.03592 12.0899C7.46609 12.5784 7.11074 13.2709 7.0463 14.0187"
      stroke="#808192"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0933 9.18184C10.9772 9.18184 11.6937 8.4653 11.6937 7.5814C11.6937 6.6975 10.9772 5.98096 10.0933 5.98096C9.2094 5.98096 8.49286 6.6975 8.49286 7.5814C8.49286 8.4653 9.2094 9.18184 10.0933 9.18184Z"
      stroke="#808192"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
